const dataProvider = require('app/www/dataProviders/client/channel');
const {SCHEDULE_GET, FAVORITE_CHANNELS_GET} = require('app/www/constants/reducerChannel');
const {userSettingsFallback} = require('app/www/actions/userSettingsFallback');
const {asyncActionError} = require('app/www/actions/asyncActionError');

function getSchedule(channelId, selectedDay) {
    return dispatch => {
        return dataProvider.getSchedule(channelId, selectedDay)
            .then(response => {
                dispatch({
                    type: SCHEDULE_GET,
                    payload: response,
                });

                dispatch(
                    userSettingsFallback(response)
                );
            });
    };
}

function getFavoriteChannels(channelIds) {
    return dispatch => {
        return dataProvider.getFavoriteChannels(channelIds)
            .then(response => {
                dispatch({
                    type: FAVORITE_CHANNELS_GET,
                    payload: response.channelIds,
                });

                dispatch(
                    userSettingsFallback(response)
                );
            })
            .catch(error => {
                dispatch(
                    asyncActionError(error)
                );
            });
    };
}

module.exports = {
    getSchedule,
    getFavoriteChannels,
};
